'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _product = require('./product/product');

var _product2 = _interopRequireDefault(_product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = 'module.sections';

angular.module(appName, [_product2.default]);

exports.default = appName;


//////////////////
// WEBPACK FOOTER
// ./app/modules/sections/sections.js
// module id = 18
// module chunks = 0